import React from 'react';

import FarmProductionRecordAddForm from './FarmProductionRecordAddForm';

export default function FarmProductionRecordAddTransplantScreen() {
  return (
    <FarmProductionRecordAddForm
      type="TRANSPLANT"
      title="Add Transplanting Records"
      successMessage="Create Transplanting Record successfully"
    />
  );
}
